// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.layout-masonry[data-v-29cf3ffb]{gap:0 60px;display:grid;grid-template-columns:repeat(auto-fill, minmax(350px, 1fr));grid-auto-rows:20px}`, "",{"version":3,"sources":["webpack://./client/components/Layout/LayoutMasonry.vue"],"names":[],"mappings":"AAGA,iCACE,UAAA,CACA,YAAA,CAEA,2DAAA,CACA,mBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
